import React, { createContext, useContext } from 'react'

// 1. Create the context
const LayerContext = createContext({
  leftHostId: null,
  fullPageHostId: null,
})

// 2. Custom hook for consuming the context
export const useLayerContext = () => useContext(LayerContext)

// 3. Provider component
export const LayerProvider = ({ children }) => {
  const leftHostId = null
  const fullPageHostId = null

  return (
    <LayerContext.Provider value={{ leftHostId, fullPageHostId }}>
      {children}
    </LayerContext.Provider>
  )
}
